import applyMask from 'component/report/utils/Formatter'
import { formatDecimalDynamic } from 'utils/masks'

export function formatColumnsByType(columns, records, translate) {
  const newValuesFormatted = []
  for (const record of records || []) {
    const row = { ...record }
    for (const col in columns) {
      const column = columns[col]
      if (column.render) {
        if (row[column.field] !== undefined) {
          row[column.field] = renderFieldValue(
            column.type,
            row[column.field],
            translate,
            column.t,
            row.numHouses
          )
        } else {
          row[column.field] = '-'
        }
      }
    }
    newValuesFormatted.push(row)
  }
  return newValuesFormatted
}

function renderFieldValue(type, field, translate, headerLabel, numHouses) {
  if (type === 'decimal') {
    if (field) {
      return formatDecimalDynamic(field, numHouses, translate)
    }
    return ''
  }
  if (type === 'percentage') {
    if (field !== 0) {
      return applyMask(type, field, translate, headerLabel)
    }
    return '-'
  }
  if (type === 'datetime') {
    if (field !== undefined) {
      return applyMask(type, field, translate, headerLabel)
    }
    return '-'
  }
  return applyMask(type, field, translate, headerLabel)
}
